<script setup lang="ts">import { useUserStore as ___useUserStore } from "@client/stores"; const $$user =  ___useUserStore();import { $socket } from "@client/lib/socket";
import { ArrowLeftIcon, SendHorizonalIcon } from "lucide-vue-next";
// import backButtonUrl from "@client/assets/svg/back-button.svg";
import { sounds } from "@client/composables/audio";
import BaseSocial from "./Base.vue";
const props = defineProps<{
	friendId?: number;
}>();

const activeComponent = defineModel<string>({ default: "Chat" });

if ($$user.pendingChatIds.has($$user.activeChatId)) $$user.removePendingChatId($$user.activeChatId);

function handleBackToFriendListClicked() {
	$$user.activeChatId = -1;
	activeComponent.value = "List";
}

const targetFriendId = props.friendId ?? $$user.activeChatId;
const targetFriend = $$user.friendList.find((friend) => friend.id === targetFriendId);
if (!$$user.chats[targetFriendId]) $$user.chats[targetFriendId] = [];
const message = ref("");
function handleSendMessage() {
	if (!message.value.trim()) return;
	$socket.social.emit("sendChat", { id: targetFriendId, content: message.value });
	$$user.chats[targetFriendId].push({ content: message.value, isSelf: true });
	localStorage.setItem("chats", JSON.stringify($$user.chats));
	message.value = "";
	sounds.message.play();
}
onBeforeUnmount(() => ($$user.activeChatId = -1));
</script>

<template>
	<BaseSocial>
		<template #prepend-title>
			<ArrowLeftIcon
				class="tw:self-center tw:justify-self-center tw:hover:scale-110 tw:cursor-pointer"
				@click="handleBackToFriendListClicked" />
		</template>
		<template #content>
			<div class="tw:px-4 tw:flex tw:items-center tw:gap-1">
				<img
					class="tw:h-[max(22px,1.8vmax)] tw:rounded-full tw:object-cover tw:aspect-square"
					:src="targetFriend?.avatarUrl!" />
				<span class="tw:truncate tw:text-[max(12px,0.8vmax)] tw:font-medium">
					{{ targetFriend?.username }}
				</span>
			</div>
			<hr class="tw:mt-2 tw:mb-6 tw:border-[#333333]" />

			<div
				class="messages-list tw:px-4 tw:max-h-[90%] tw:overflow-y-auto tw:flex tw:flex-col tw:gap-2">
				<p v-if="!$$user.chats[targetFriendId].length" class="tw:text-center tw:text-sm">
					No messages
				</p>
				<div v-for="data in $$user.chats[targetFriendId]" class="tw:text-sm">
					<div class="tw:flex tw:gap-1 tw:hover:bg-neutral-700 tw:rounded-md tw:p-1">
						<img
							class="tw:h-[max(16px,1.3vmax)] tw:rounded-full tw:object-cover tw:aspect-square"
							:src="
								data.isSelf ? $$user.user.avatarUrl! : targetFriend?.avatarUrl!
							" />
						<div class="tw:w-[80%] tw:flex tw:flex-col tw:px-2">
							<p class="tw:text-xs tw:font-semibold tw:text-white">
								{{ data.isSelf ? $$user.user.username : targetFriend?.username }}
							</p>
							<p class="tw:rounded-md tw:break-words">
								{{ data.content }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #footer-left>
			<v-text-field
				class="chat-input"
				@keydown.enter="handleSendMessage"
				v-model="message"
				density="compact"
				variant="solo"
				placeholder="Type a message"
				hide-details />
			<SendHorizonalIcon class="tw:cursor-pointer" @click="handleSendMessage" />
		</template>
	</BaseSocial>
</template>
<style scoped lang="scss">
.messages-list {
	scrollbar-width: thin;
}
</style>
<!-- // import { useSound } from "@vueuse/sound";
// import message_sound from "@client/assets/sound/message.mp3";
// const { play: playMessageSound } = useSound(message_sound); -->
